// 301 from the legacy /split-pdf path to the canonical /split (brief §1).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/split-pdf")({
  beforeLoad: () => {
    throw redirect({ to: "/split", statusCode: 301 });
  },
});
